export default __webpack_public_path__ + "static/media/A5_LANDSCAPE_COPY_DF.473a8541.png";